import { Box } from '@mui/material';

import { useSideNavigationAnimation } from '../Animation';
import {
  CUSTOM_SCROLL_BAR_SIZE_IN_PIXELS,
  NAVIGATION_HORIZONTAL_PADDING,
  customScrollbarStyles,
} from '../Theme';
import { SIDEBAR_NAVIGATION_DRAWER_WIDTH } from '../constants';
import { SidebarNavigationLink } from './lib/Link';
import { SidebarNavigationLinkAccordion } from './lib/LinkAccordion';
import { useSidebarNavigationRouteSectionsContext } from './lib/sidebarRoutes';

export function SidebarNavigationMiddleSection() {
  const { sideNavigationOpacityAnimation } = useSideNavigationAnimation();
  const { navigationRouteSections } = useSidebarNavigationRouteSectionsContext();

  return (
    <Box
      sx={{
        overflowY: 'auto',
        overflowX: 'hidden',
        flexGrow: 1,
        ...customScrollbarStyles,
        scrollbarGutter: 'stable both-edges',
        width: SIDEBAR_NAVIGATION_DRAWER_WIDTH,
        ...sideNavigationOpacityAnimation,
      }}
    >
      {navigationRouteSections.map((routeSectionOrLink) => {
        if ('to' in routeSectionOrLink) {
          return (
            <SidebarNavigationLink
              key={routeSectionOrLink.label}
              link={routeSectionOrLink}
              borderMode="None"
              sx={{
                paddingLeft: `${NAVIGATION_HORIZONTAL_PADDING - CUSTOM_SCROLL_BAR_SIZE_IN_PIXELS}px`,
                paddingRight: `${NAVIGATION_HORIZONTAL_PADDING - CUSTOM_SCROLL_BAR_SIZE_IN_PIXELS}px`,
              }}
            />
          );
        }
        return (
          <SidebarNavigationLinkAccordion
            key={routeSectionOrLink.label}
            routeSection={routeSectionOrLink}
          />
        );
      })}
    </Box>
  );
}
